import { type CSSProperties, useMemo } from 'react';

import { useEditCanvasStore } from '../store';
import { useIsArtworkOffScreen } from './useIsArtworkOffScreen';
import { useToolbarOffset } from './useToolbarOffset';

/** Matches the bottom margin of `CanvasBottomHint` and `TOAST_BOTTOM_OFFSET` in core. */
const BOTTOM_LANE_PX = 72;
/** Rendered height of `CanvasBottomHint`: a 20px row plus `py-1.5` and a 1px border. */
const BOTTOM_HINT_HEIGHT_PX = 34;
const STACK_GAP_PX = 8;

/** Style for a bottom-center `Panel` that sits in the lane above the toolbar and rises above the bottom hints. */
export const useCanvasBottomLaneStyle = () => {
  const toolbarOffsetStyle = useToolbarOffset();
  const isArtworkOffScreen = useIsArtworkOffScreen();
  const armedCanvasToolId = useEditCanvasStore((state) => state.armedCanvasToolId);
  const isBottomHintVisible = isArtworkOffScreen || !!armedCanvasToolId;

  const bottomLaneStyle = useMemo((): CSSProperties => {
    const hintLift = isBottomHintVisible ? BOTTOM_HINT_HEIGHT_PX + STACK_GAP_PX : 0;

    return {
      ...toolbarOffsetStyle,
      margin: `0 16px ${BOTTOM_LANE_PX + hintLift}px`,
      transition: 'transform 300ms ease, margin 200ms ease',
    };
  }, [isBottomHintVisible, toolbarOffsetStyle]);

  return { bottomLaneStyle };
};
